import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const UploadCallToActionContainer = styled.div`
  margin-bottom: 16px;
`;

const UploadCallToAction = () => {
  const { t } = useTranslation();

  return (
    <UploadCallToActionContainer>
      {t('profile.upload_invite')}
    </UploadCallToActionContainer>
  );
};

export default UploadCallToAction;
